import { computed, Injectable, signal } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocalStorageService } from './local.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly _destroying$ = new Subject<void>();

  private readonly currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  private authStatusSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public authStatus$: Observable<boolean> = this.authStatusSubject.asObservable();

  private readonly _token = signal<string | null>(null);
  readonly token = computed(() => this._token());

  constructor(
    private readonly oidcService: OidcSecurityService,
    private readonly storage: LocalStorageService
  ) {
    const dados_usuario = storage.getItem('currentUser') || '';
    this.currentUserSubject = new BehaviorSubject<any>(dados_usuario);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  init() {
    // Monitora mudanças de autenticação
    this.oidcService.isAuthenticated$
      .pipe(takeUntil(this._destroying$))
      .subscribe(({ isAuthenticated }) => {
        this.authStatusSubject.next(isAuthenticated);

        if (isAuthenticated) {
          this.loadUserDetails();
        }
      });
  }

  setToken(token: string) {
    this._token.set(token);
  }

  clearToken() {
    this._token.set(null);
  }

  get authenticated(): boolean {
    return this.authStatusSubject.value;
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  login() {
    console.log('Service - Logar...');
    this.oidcService.authorize();
  }

  logout() {
    console.log('Logout...');
    this.clearToken();
    this.storage.removeItem('currentUser');
    this.storage.clear();
    this.authStatusSubject.next(false);

    this.oidcService.logoff()
      .pipe(takeUntil(this._destroying$))
      .subscribe();
  }

  isAuthenticated(): Observable<boolean> {
    return this.authStatus$;
  }

  getUserDetails(): { name?: string; email: string } | null {
    return this.loadUserDetails();
  }

  private loadUserDetails(): { name?: string; email: string } | null {
    let userData: any = null;

    this.oidcService.getUserData()
      .pipe(takeUntil(this._destroying$))
      .subscribe(data => {
        userData = data;
      });

    if (!userData) {
      console.warn('Conta não encontrada.');
      return null;
    }

    const email = userData.email ?? userData.preferred_username ?? '';
    const name = userData.name ?? '';

    if (!email) {
      console.error('Email não encontrado no Perfil.');
      return null;
    }

    const userProfile = {
      name: name || undefined,
      email: email
    };

    this.storage.setItem('currentUser', JSON.stringify(userProfile));
    this.currentUserSubject.next(JSON.stringify(userProfile));

    return userProfile;
  }

  destroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}